import React from 'react';

const ModalBody = ({
    children,
} : {
    children: React.ReactNode
}) => {
    return (
        <div className='p-4'>
            {children}
        </div>
    );
};
export default ModalBody;
